import { useMytaverseEvent } from '../../../../providers';
import { useEffect, useState } from 'react';
import { getLoadingIntervals } from './helper';

const UPDATE_INTERVAL = 100;

export const useGameCastSteps = () => {
  const { initMessageSended, currentRoom, isStreamLoaded } =
    useMytaverseEvent();

  const secondStepLoading = !initMessageSended;
  const secondStepCompleted = initMessageSended;
  const thirdStepLoading = secondStepCompleted && !isStreamLoaded;
  const thirdStepCompleted = secondStepCompleted && isStreamLoaded;
  const forthStepLoading = thirdStepCompleted && !currentRoom;
  const forthStepCompleted = thirdStepCompleted && !!currentRoom;

  return {
    secondStepLoading,
    secondStepCompleted,
    thirdStepLoading,
    thirdStepCompleted,
    forthStepLoading,
    forthStepCompleted,
  };
};

export const useGameCastProgressBar = ({
  isStreamLoaded,
  isUeLoaded,
}: {
  isStreamLoaded: boolean;
  isUeLoaded: boolean;
}) => {
  const { currentEvent } = useMytaverseEvent();

  const [progressValue, setProgressValue] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      const { gameliftInitTime, ueInitTime, delay } = getLoadingIntervals(
        currentEvent?.settings?.timerLoadingTimeMins || null,
      );

      setProgressValue((prevProgress) => {
        if (isStreamLoaded && prevProgress < 75) {
          return 75;
        }
        if (isUeLoaded && prevProgress < 90) {
          return 90;
        }
        if (prevProgress >= 100) {
          return 100;
        }

        if (prevProgress < 75) {
          const increment = (70 / gameliftInitTime) * (UPDATE_INTERVAL / 1000);
          return Math.min(75, prevProgress + increment);
        } else if (prevProgress < 90) {
          if (!isStreamLoaded) {
            return prevProgress;
          }

          const increment = (15 / ueInitTime) * (UPDATE_INTERVAL / 1000);
          return Math.min(90, prevProgress + increment);
        } else {
          if (!isUeLoaded) {
            return prevProgress;
          }

          const increment = (10 / delay) * (UPDATE_INTERVAL / 1000);
          return Math.min(100, prevProgress + increment);
        }
      });
    }, UPDATE_INTERVAL);

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [
    isStreamLoaded,
    isUeLoaded,
    currentEvent?.eventTags,
    currentEvent?.settings?.timerLoadingTimeMins,
  ]);

  return progressValue;
};
